import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareMonthDatePicker from '../../../../common/inputfields/ErrorAwareMonthDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class ModifySalary extends Component {

    componentDidMount() {
        console.log(this.props);
    }
    state = {
        selectedPaymentMethod: enums.outPaymentMethods.find(p => p.value === this.props.row.paymentMethod),
        netSalary: this.props.row.netSalary,
        date: new Date(this.props.row.year, this.props.row.month - 1, 1),
        errors: new Map()
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/salary';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "netSalary": util.toNumber(this.state.netSalary),
            "employeeId": this.props.row.employeeId,
            "month": this.state.date.getMonth() + 1,
            "year": this.state.date.getFullYear(),
        };
        handlePatch(path, requestObject, this);
    };

    getPrevDate = () => {
        return new Date(this.props.row.year, this.props.row.month - 1, 1);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="employee"
                            label="Munkavállaló"
                            errors={this.state.errors}
                            value={this.props.row.employeeName} />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            prevValue={enums.getObjectByValue(enums.outPaymentMethods, this.props.row.paymentMethod)}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="netSalary"
                            label="Nettó fizetés"
                            errors={this.state.errors}
                            value={this.state.netSalary}
                            prevValue={this.props.row.netSalary}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareMonthDatePicker
                            required
                            name="date"
                            label="Év és hónap"
                            errors={this.state.errors}
                            value={this.state.date}
                            prevValue={this.getPrevDate()}
                            onChange={value => this.setState({ date: value })} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosít
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifySalary);
